import React from 'react';

export default (props) => {
  return 'No Recipients';
};
